//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'LayoutDefault',

  data() {
    return {
      isLogin: false,
      leftDrawerOpen: false,
      user:{},
      showChannelPanel:false
    }
  },
  mounted() {
    const cookies = this.$q.cookies.getAll()
    const token = this.$q.cookies.get('becbas_token')
    if (token != undefined) {
      this.isLogin = true
      var that = this;
      this.$axios
        .get('/api/beijing/currUserInfo?from=quasar')
        .then(function (response) {
          that.loading = false
          let data = response.data.data;
          that.user = data;
            if(data.role_id==1){
              that.showChannelPanel = true;
            }
          })
        .catch(function (error) { // 请求失败处理
          that.loading = false
          console.log(error);
        });
    }
  },
  computed: {
    title() {
      return this.$route.meta && this.$route.meta.title
    }
  }
}
